import {CalendarActionCreators} from "./calendar/calendarActionCreators";


export const AllActionsCreators = {
    ...CalendarActionCreators
}
